import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useLang } from "../lib/providers";
import { Home, Search } from "lucide-react";

export default function NotFoundPage() {
  const { lang } = useLang();
  return (
    <div className="min-h-screen text-white" dir={lang === "ar" ? "rtl" : "ltr"} data-testid="not-found-page">
      <Header />
      <main className="pt-24 pb-20 px-4 text-center">
        <p className="font-heading font-black text-neon text-7xl sm:text-8xl mb-4">404</p>
        <h1 className="font-heading font-black uppercase tracking-tight text-2xl sm:text-3xl mb-3">
          {lang === "ar" ? "الصفحة غير موجودة" : "Page introuvable"}
        </h1>
        <p className="text-sm text-white/60 mb-8 max-w-md mx-auto">
          {lang === "ar"
            ? "الصفحة التي تبحث عنها غير موجودة أو تم نقلها."
            : "La page que vous cherchez n'existe pas ou a été déplacée."}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-neon text-black font-black uppercase tracking-widest text-xs px-6 py-3 hover:opacity-90 transition-opacity"
            data-testid="not-found-home-link"
          >
            <Home className="w-4 h-4" />
            {lang === "ar" ? "العودة للرئيسية" : "Retour à l'accueil"}
          </Link>
          <Link
            to="/#produits"
            className="inline-flex items-center gap-2 border border-white/20 text-white font-black uppercase tracking-widest text-xs px-6 py-3 hover:border-neon hover:text-neon transition-colors"
            data-testid="not-found-products-link"
          >
            <Search className="w-4 h-4" />
            {lang === "ar" ? "تصفح المنتجات" : "Voir les produits"}
          </Link>
        </div>
      </main>
    </div>
  );
}
